import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid,
    Tooltip, Legend, ResponsiveContainer
} from "recharts";

export default function GraficoResumo({ dados }) {

    // Agrupa por franquia e calcula diferença primeiro/último
    const porFranquia = {};
    dados.forEach((item) => {
        if (!porFranquia[item.id_franquia]) porFranquia[item.id_franquia] = [];
        porFranquia[item.id_franquia].push(item);
    });

    const dadosGrafico = Object.keys(porFranquia).map((id_franquia) => {
        const registros = [...porFranquia[id_franquia]].sort((a, b) =>
            a.data_registro.localeCompare(b.data_registro)
        );
        const primeiro = registros[0];
        const ultimo = registros[registros.length - 1];

        // Abrevia o nome para caber no gráfico
        const nomeCurto = ultimo.nome_franquia.replace("Casa Lúdica ", "");

        return {
            nome: nomeCurto,
            Seguidores: ultimo.seguidores - primeiro.seguidores,
            Postagens: ultimo.postagens - primeiro.postagens,
        };
    }).sort((a, b) => b.Seguidores - a.Seguidores);

    return (
        <div style={{ width: "100%", marginTop: 20 }}>
            <ResponsiveContainer width="100%" height={350}>
                <BarChart
                    data={dadosGrafico}
                    barSize={25}
                    barCategoryGap="10%"
                    margin={{ top: 10, right: 450, left: 0, bottom: 60 }}
                >
                    <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
                    <XAxis
                        dataKey="nome"
                        tick={{ fontSize: 9, fill: "#666" }}
                        angle={-15}
                        textAnchor="end"
                        interval={0}
                    />
                    <YAxis tick={{ fontSize: 11, fill: "#666" }} />
                    <Tooltip
                        contentStyle={{ fontSize: 9, borderRadius: 8 }}
                    />
                    <Legend
                        content={() => (
                            <div style={{ display: "flex", gap: 16, justifyContent: "center", fontSize: 12, paddingTop: 10 }}>
                                {[
                                    { label: "Seguidores", color: "#282bdd" },
                                    { label: "Postagens", color: "#f09433" },                                
                                ].map(item => (
                                    <div key={item.label} style={{ display: "flex", alignItems: "center", gap: 4 }}>
                                        <div style={{ width: 12, height: 12, backgroundColor: item.color, borderRadius: 2 }} />
                                        <span style={{ color: "#666" }}>{item.label}</span>
                                    </div>
                                ))}
                            </div>
                        )}
                    />
                    <Bar dataKey="Seguidores" fill="#282bdd" radius={[4, 4, 0, 0]} />
                    <Bar dataKey="Postagens" fill="#f09433" radius={[4, 4, 0, 0]} />

                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}